<template>
  <div class="auth">
    <div class="auth__form">
      <div class="auth__logo">
        <img src="/static/images/logo.svg" alt="vcv" />
      </div>

      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </div>

    <div class="auth__banner">
      <img class="auth__banner-background" src="/static/images/login/not-rectangle.svg" alt="" />

      <div class="auth__banner-header">
        <div class="auth__banner-header1">
          {{ $tr('login.want-company-growth') }}
        </div>
        <div class="auth__banner-header2">
          {{ $tr('login.collect-best-team') }}
        </div>
        <div class="auth__banner-header3">{{ $tr('login.header3') }}</div>
      </div>

      <img class="auth__banner-girl" src="/static/images/login/girl.png" alt="" />
      <div class="auth__banner-we">{{ $tr('login.we-glad-your-response') }}</div>
      <div class="auth__banner-modal">
        <div class="auth__banner-modal-header">{{ $tr('vacancy.create.newVacancy') }}</div>
        <div class="auth__banner-modal-choose">
          {{ $tr('vacancy.preferences.special.SFSelectVacancy') }}
        </div>
        <div class="auth__banner-modal-select">
          {{ $tr('admin_console.company.label.admin-company-settings-managers') }}
          <i class="icon icon-caret"></i>
        </div>
        <div class="auth__banner-modal-line"></div>
        <div class="auth__banner-modal-buttons">
          <span>{{ $tr('settings.statuses.cancel') }}</span>
          <span class="auth__banner-modal-ok">{{ $tr('common.ok') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { load_script } from '@/_helpers/utils.js';

export default {
  name: 'VcvAuth',

  mounted() {
    load_script('https://www.google.com/recaptcha/api.js', 'recaptcha', () => {}, 'defer');
  }
};
</script>

<style lang="scss" scoped>
.auth {
  width: 100%;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  font-size: 1em;

  @media screen and (min-width: 2000px) {
    font-size: 1.2em;
  }

  @media screen and (min-width: 2500px) {
    font-size: 1.3em;
  }

  @media screen and (min-width: 3000px) {
    font-size: 1.4em;
  }

  @media screen and (min-width: 3500px) {
    font-size: 1.5em;
  }

  @media screen and (min-width: 4000px) {
    font-size: 2.4em;
  }

  @media screen and (max-height: 1100px) {
    font-size: 1.1em;
  }

  @media screen and (max-height: 950px) {
    font-size: 1em;
  }

  @media screen and (max-width: 1300px) and (max-height: 850px) {
    font-size: 0.75em;
  }

  @media screen and (max-width: 1300px) and (max-height: 800px) {
    font-size: 0.7em;
  }

  @media screen and (max-width: 1200px) and (max-height: 800px) {
    font-size: 0.7em;
  }

  &__form {
    min-height: 100vh;
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 18px;

    @media screen and (max-width: 1000px) {
      width: 100%;
    }

    @media screen and (max-width: 1400px) and (orientation: portrait) {
      width: 100%;
    }

    @media (min-aspect-ratio: 21/9) {
      width: 75%;
    }
  }

  &__logo {
    margin-bottom: 25px;
    display: flex;
    justify-content: center;
    height: 44px;

    @media screen and (orientation: landscape) and (max-height: 450px) {
      height: 20px;
      margin-bottom: 15px;
    }

    > img {
      height: 100%;
      width: auto;
    }
  }

  &__banner-background {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;

    > img {
      height: 100%;
      width: auto;
    }
  }

  &__banner {
    pointer-events: none;

    @media screen and (max-width: 1000px) {
      display: none;
    }
    @media screen and (max-width: 1400px) and (orientation: portrait) {
      display: none;
    }
  }

  &__banner-header {
    color: #fff;
    position: absolute;
    top: 13em;
    right: 2em;
    max-width: 30em;
  }

  &__banner-header1 {
    font-style: italic;
    font-weight: 500;
    font-size: 1.85em;
    margin-bottom: 0.35em;
  }

  &__banner-header2 {
    font-weight: 600;
    font-size: 3em;
    margin-bottom: 0.7em;
  }

  &__banner-header3 {
    font-weight: 600;
    font-size: 1em;
  }

  &__banner-girl {
    position: absolute;
    bottom: 2em;
    right: 2em;
    width: 19em;
    z-index: 2;
  }

  &__banner-we {
    position: absolute;
    bottom: 14em;
    right: 17em;
    height: 3em;
    padding: 0.7em 1.4em;
    color: $main-dark;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 1.9em;
    z-index: 3;
  }

  &__banner-modal {
    background: #fff;
    padding: 1em 2em 0.8em 1em;
    position: absolute;
    bottom: 2.5em;
    right: 16.5em;
    border-radius: 1em;
    z-index: 1;
    box-shadow: $box-shadow;
  }

  &__banner-modal-header {
    display: inline-block;
    background: #0096ff;
    color: #fff;
    padding: 0.32em 0.65em;
    border-radius: 0.5em;
    margin-bottom: 0.8em;
  }

  &__banner-modal-choose {
    color: $grey;
    margin-bottom: 0.3em;
    font-size: 0.875em;
  }

  &__banner-modal-select {
    border: 1px solid $grey;
    border-radius: 0.2em;
    position: relative;
    padding: 0.25em 2em 0.25em 0.75em;
    width: 100%;
    font-size: 0.8em;
    color: $main-dark;

    i {
      position: absolute;
      top: 50%;
      right: 0.625em;
      color: $main-dark;
      transform: translateY(-40%);
    }
  }

  &__banner-modal-line {
    background: $grey-light;
    height: 1px;
    width: 100%;
    margin: 0.85em auto;
  }

  &__banner-modal-buttons {
    font-size: 0.625em;
    display: flex;
    justify-content: flex-end;

    span {
      display: inline-block;
      padding: 0.3em 0.6em;
      border-radius: 0.35em;

      &:first-child {
        margin-right: 0.7em;
      }
    }
  }

  &__banner-modal-ok {
    background: #0096ff;
    color: #fff;
  }
}

.scale-in-center {
  animation: scale-in-center 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0.5s both;
}
.fade-in-delayed1 {
  animation: fade-in 0.25s cubic-bezier(0.39, 0.575, 0.565, 1) 1s both;
}
.fade-in-delayed2 {
  animation: fade-in 0.25s cubic-bezier(0.39, 0.575, 0.565, 1) 1.25s both;
}

@keyframes scale-in-center {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
